/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ReorderIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M10 26C9.44772 26 9 25.5523 9 25L9 5C9 4.44771 9.44771 4 10 4C10.5523 4 11 4.44771 11 5L11 25C11 25.5523 10.5523 26 10 26Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15.7071 19.2929C15.3166 18.9024 14.6834 18.9024 14.2929 19.2929L9.29289 24.2929C8.90237 24.6834 8.90237 25.3166 9.29289 25.7071C9.68342 26.0976 10.3166 26.0976 10.7071 25.7071L15.7071 20.7071C16.0976 20.3166 16.0976 19.6834 15.7071 19.2929Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.29289 19.2929C4.68342 18.9024 5.31658 18.9024 5.70711 19.2929L10.7071 24.2929C11.0976 24.6834 11.0976 25.3166 10.7071 25.7071C10.3166 26.0976 9.68342 26.0976 9.29289 25.7071L4.29289 20.7071C3.90237 20.3166 3.90237 19.6834 4.29289 19.2929Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M22 6C22.5523 6 23 6.44772 23 7V27C23 27.5523 22.5523 28 22 28C21.4477 28 21 27.5523 21 27V7C21 6.44772 21.4477 6 22 6Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M27.7071 12.7071C27.3166 13.0976 26.6834 13.0976 26.2929 12.7071L21.2929 7.70711C20.9024 7.31658 20.9024 6.68342 21.2929 6.29289C21.6834 5.90237 22.3166 5.90237 22.7071 6.29289L27.7071 11.2929C28.0976 11.6834 28.0976 12.3166 27.7071 12.7071Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M16.2929 12.7071C16.6834 13.0976 17.3166 13.0976 17.7071 12.7071L22.7071 7.70711C23.0976 7.31658 23.0976 6.68342 22.7071 6.29289C22.3166 5.90237 21.6834 5.90237 21.2929 6.29289L16.2929 11.2929C15.9024 11.6834 15.9024 12.3166 16.2929 12.7071Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
